const DATASET_SORTING = 'dataset';
const PRIORITY_SORTING = 'requestPriorityRules';

export const SortingRuleType = Object.freeze({
    [DATASET_SORTING]: 1,
    [PRIORITY_SORTING]: 2,
});

export const SortingRuleTypeNames = Object.freeze({
    1: DATASET_SORTING,
    2: PRIORITY_SORTING,
});
